import { useTranslation } from 'react-i18next';
import { type UserlikeChatbotModuleSpecsFragment } from '../../../../../api/fragments/UserlikeChatbotModuleSpecs';
import {
    CreateUserlikeChatbotModuleDocument,
    type CreateUserlikeChatbotModuleMutation,
    type CreateUserlikeChatbotModuleMutationVariables,
} from '../../../../../api/mutations/createUserlikeChatbotModule';
import { type UserlikeChatbotModuleInput } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import UserlikeChatbotModulePage, { type UserlikeChatbotModulePageProps } from '../../UserlikeChatbotModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<UserlikeChatbotModuleSpecsFragment, UserlikeChatbotModuleInput> = {
    PageComponent: ({ module }: UserlikeChatbotModulePageProps) => <UserlikeChatbotModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.UserlikeChatbotModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateUserlikeChatbotModuleMutation, CreateUserlikeChatbotModuleMutationVariables>({
                mutation: CreateUserlikeChatbotModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
